<template>
  <header class="header">
    <div class="header__nav" @click="toggleMenu"></div>
    <div class="header__logo">
      <a href="https://www.desivero.com/" target="_blank" title="Desivero"></a>
    </div>
    <div class="header__back"
         v-show="hasBack"
         @click="retrievePrevStep">
      <a href="#"></a>
    </div>
  </header>
</template>

<script>
  export default{
    data(){
      return {
      }
    },
    computed:{
      hasBack(){
        return this.$store.state.hasBack;
      }
    },
    methods: {
      toggleMenu(){
        this.$store.state.isNavOpen = !this.$store.state.isNavOpen;
      },
      updateParentProps(){
        var vm = this;
        var config = vm.$store.state.tempConfigObj;
        if (config) {
          vm.$emit('update-props', config);
          this.$forceUpdate();
        }
      },
      retrievePrevStep(){
        var vm = this;
        var questionId = vm.$store.state.tempConfigObj.id;
        vm.makeBackCall(questionId, function () {
          vm.updateParentProps();
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/globals/Header.vue